export type QuickActionDefinition = {
  id: string;
  title: string;
  icon: string;
};

export const QUICK_ACTION_ALIASES: Record<string, string> = {
  giving: 'give',
  give: 'give',
  sermons: 'sermons',
  connect: 'connect',
  social: 'connect',
  myGroups: 'myGroups',
  my_groups: 'myGroups',
  groups: 'myGroups',
  events: 'events',
  announcements: 'announcements',
  devotionals: 'devotionals',
  confessions: 'confessions',
  kidsChurch: 'kidsChurch',
  kids_church: 'kidsChurch',
  volunteer: 'volunteer',
  businesses: 'businesses',
  bookStore: 'bookStore',
  book_store: 'bookStore',
  bookstore: 'bookStore',
  becomePartner: 'becomePartner',
  become_partner: 'becomePartner',
  partner: 'becomePartner',
  servicePlanner: 'servicePlanner',
  service_planner: 'servicePlanner',
  serviceplanner: 'servicePlanner',
  requestRide: 'requestRide',
  request_ride: 'requestRide',
  requestride: 'requestRide',
  classroom: 'classroom',
  class_room: 'classroom',
};

export const QUICK_ACTION_DEFINITIONS: QuickActionDefinition[] = [

  { id: 'sermons', title: 'Sermons', icon: 'microphone' },
  { id: 'connect', title: 'Connect', icon: 'account-group' },
  { id: 'devotionals', title: 'Devotionals', icon: 'book-open-page-variant' },
  { id: 'myGroups', title: 'My Groups', icon: 'account-multiple' },
  { id: 'events', title: 'Events', icon: 'calendar-month' },
  { id: 'announcements', title: 'Announcements', icon: 'bullhorn' },
  { id: 'confessions', title: 'Confessions', icon: 'hands-pray' },
  { id: 'kidsChurch', title: 'Kids Church', icon: 'baby-face-outline' },
  { id: 'volunteer', title: 'Volunteer', icon: 'account-heart' },
  { id: 'businesses', title: 'Businesses', icon: 'storefront' },
  { id: 'becomePartner', title: 'Become a Partner', icon: 'account-plus' },
  { id: 'give', title: 'Give', icon: 'hand-heart' },
  { id: 'servicePlanner', title: 'Service Plan', icon: 'clipboard-list' },
  { id: 'requestRide', title: 'Request Ride', icon: 'car' },
  { id: 'bookStore', title: 'Book Store', icon: 'book-open-page-variant' },
  { id: 'classroom', title: 'Classroom', icon: 'google-classroom' },
];

/**
 * Filenames under `public/quick-actions/` — same artwork as mobile `HomeScreen` quick-action tiles.
 * If `quick_actions` in Supabase has a full `https` `backgroundImage`, that URL is used instead in the admin UI.
 */
export const QUICK_ACTION_HOME_IMAGE_FILE: Record<string, string> = {
  sermons: 'sermonImgTxt.png',
  connect: 'connectImgTxt.png',
  give: 'GiveImgTxt.png',
  myGroups: 'groupImgTxt.png',
  events: 'eventImgTxt.png',
  announcements: 'annoucementsImgTxt.png',
  devotionals: 'devotionalImgTxt.png',
  confessions: 'declarationsImgTxt.png',
  kidsChurch: 'kidsChurchImgTxt.png',
  volunteer: 'volunteerImgTxt2.png',
  businesses: 'businessImgTxt.png',
  becomePartner: 'PartnerImgTxt.png',
  servicePlanner: 'plannerImgTxt.png',
  requestRide: 'requestRideImgTxt.png',
  bookStore: 'bookStoreImgTxt.png',
  classroom: 'classroomImgTxt.png',
};

export const getQuickActionAdminPreviewUrl = (
  actionId: string,
  backgroundImageFromConfig?: string | null
): string | null => {
  const trimmed = typeof backgroundImageFromConfig === 'string' ? backgroundImageFromConfig.trim() : '';
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  const file = QUICK_ACTION_HOME_IMAGE_FILE[actionId];
  if (!file) return null;
  const base = (typeof process !== 'undefined' && process.env?.PUBLIC_URL ? process.env.PUBLIC_URL : '').replace(/\/$/, '');
  return `${base}/quick-actions/${file}`;
};
